// extracted by mini-css-extract-plugin
module.exports = {"image":"ArticleContent_image__8SXmZ","content":"ArticleContent_content__1yKH3","embed":"ArticleContent_embed__d4Eyx","share":"ArticleContent_share__2Izq6"};